<template>
  <router-link
    v-slot="slotData"
    v-bind="$attrs"
    :to="toLocation"
    active-class="active"
    exact-active-class="exact-active"
  >
    <slot v-bind="slotData" />
  </router-link>
</template>

<script lang="ts" setup>
import { toRef } from 'vue';
import type { RouteLocationRaw } from 'vue-router';
import { useLocation } from '@/hooks/location';

interface Props {
  to: RouteLocationRaw;
}

const props = defineProps<Props>();
const toLocation = useLocation(toRef(props, 'to'));
</script>

<style lang="scss" scoped></style>
